import { Component, EventEmitter, Output } from '@angular/core';
@Component({
  selector: 'app-features-activation-tab',
  templateUrl: './features-activation-tab.component.html',
  styleUrls: ['./features-activation-tab.component.scss'],
})
export class FeaturesActivationTabComponent {
  @Output() hideButton = new EventEmitter();
  public tabIndex = 0;

  public tabChanged(tabIndex: number): void {
    this.hideButton.emit(tabIndex);
  }
}
